// gavion.email.attention.* — A12: sends on hold or needing an admin check (FR/EN parity is tested globally).
export const attentionMessages = {
  fr: {
    nav: "À vérifier",
    title: "Envois bloqués ou à vérifier",
    intro:
      "Envois en attente : la séquence réessaie seule toutes les heures dès que la cause est réglée. Envois à vérifier : on ne sait pas si le courriel est parti ; il n'est jamais renvoyé (pas de doublon). Vérifiez dans la boîte d'envoi ou auprès de la compagnie. Les envois à vérifier restent affichés 30 jours.",
    banner: {
      held: "1 envoi en attente |||| %{smart_count} envois en attente",
      review: "1 envoi à vérifier |||| %{smart_count} envois à vérifier",
      link: "Voir les envois bloqués",
    },
    empty: "Aucun envoi bloqué ni à vérifier.",
    load_error: "Impossible de charger les envois à vérifier.",
    columns: {
      kind: "État",
      source: "Origine",
      target: "Destinataire ou action",
      reason: "Pourquoi",
      at: "Date",
      open: "Lien",
    },
    open: "Ouvrir",
    kind: {
      held: "En attente",
      review: "À vérifier",
    },
    source: {
      sequence: "Séquence",
      automation: "Automatisation",
      campaign: "Campagne",
    },
    reasons: {
      graph_unavailable:
        "Microsoft 365 n'est pas branché pour ce représentant : l'envoi attend (Paramètres → Intégrations).",
      template_draft:
        "Le modèle n'est pas approuvé (brouillon) : approuvez-le dans Courriels → Modèles.",
      template_archived:
        "Le modèle est archivé : remplacez l'étape ou restaurez le modèle.",
      ses_not_configured:
        "Amazon SES n'est pas encore configuré : cette étape attend SES.",
      no_owner:
        "Aucun vendeur assigné : la compagnie n'a pas de représentant actif, l'envoi Outlook attend et réessaie toutes les heures (assignez un représentant à la compagnie, ou retirez-la de la séquence).",
      microsoft_not_connected:
        "Microsoft 365 n'est pas connecté (ou doit être reconnecté) pour le représentant de la compagnie : l'envoi Outlook attend et réessaie toutes les heures (Paramètres → Intégrations).",
      graph_send_unknown:
        "Résultat d'envoi Microsoft inconnu : vérifiez les Éléments envoyés dans Outlook.",
      in_flight:
        "Envoi interrompu en cours de route : vérifiez s'il est parti.",
      unknown_after_crash:
        "Interruption pendant l'envoi : vérifiez s'il est parti.",
      no_message_id:
        "Amazon SES n'a pas confirmé l'envoi : vérifiez s'il est parti.",
      exception: "Erreur inattendue pendant l'envoi : vérifiez s'il est parti.",
      reconcile_unknown:
        "Le résultat de l'envoi n'a pas pu être confirmé : vérifiez s'il est parti.",
      reconcile_unavailable:
        "Le fournisseur n'a pas répondu à la vérification : vérifiez s'il est parti.",
      attachments_missing:
        "La pièce jointe (la vidéo) du modèle est introuvable : rattachez-la au modèle, l'envoi reprendra.",
      attachment_unavailable:
        "La pièce jointe du modèle n'est pas disponible pour le moment : l'envoi réessaie plus tard.",
      unknown: "Raison inconnue.",
    },
  },
  en: {
    nav: "To check",
    title: "Sends on hold or to check",
    intro:
      "On hold: the sequence retries on its own every hour once the cause is fixed. To check: we do not know whether the email went out; it is never sent again (no duplicate). Check the sent folder or with the lead. Sends to check stay listed for 30 days.",
    banner: {
      held: "1 send on hold |||| %{smart_count} sends on hold",
      review: "1 send to check |||| %{smart_count} sends to check",
      link: "View blocked sends",
    },
    empty: "No send on hold or to check.",
    load_error: "Could not load the sends to check.",
    columns: {
      kind: "State",
      source: "Source",
      target: "Recipient or action",
      reason: "Why",
      at: "Date",
      open: "Link",
    },
    open: "Open",
    kind: {
      held: "On hold",
      review: "To check",
    },
    source: {
      sequence: "Sequence",
      automation: "Automation",
      campaign: "Campaign",
    },
    reasons: {
      graph_unavailable:
        "Microsoft 365 is not wired for this rep: the send waits (Settings → Integrations).",
      template_draft:
        "The template is not approved (draft): approve it in Emails → Templates.",
      template_archived:
        "The template is archived: replace the step or restore the template.",
      ses_not_configured:
        "Amazon SES is not configured yet: this step waits for SES.",
      no_owner:
        "No rep assigned: the lead has no active rep, so the Outlook send waits and retries every hour (assign a rep to the lead, or remove it from the sequence).",
      microsoft_not_connected:
        "Microsoft 365 is not connected (or needs reconnecting) for the lead's rep: the Outlook send waits and retries every hour (Settings → Integrations).",
      graph_send_unknown:
        "Microsoft send outcome unknown: check Sent Items in Outlook.",
      in_flight: "The send was interrupted mid-way: check whether it went out.",
      unknown_after_crash:
        "Interrupted while sending: check whether it went out.",
      no_message_id:
        "Amazon SES did not confirm the send: check whether it went out.",
      exception: "Unexpected error while sending: check whether it went out.",
      reconcile_unknown:
        "The send outcome could not be confirmed: check whether it went out.",
      reconcile_unavailable:
        "The provider did not answer the check: check whether it went out.",
      attachments_missing:
        "The template's attachment (the video) is missing: attach it to the template and the send will resume.",
      attachment_unavailable:
        "The template's attachment is unavailable right now: the send will retry later.",
      unknown: "Unknown reason.",
    },
  },
};
